var _path, _rect, _rect2, _rect3, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPayoutSettings(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.622 4.734a1.25 1.25 0 01.756 0l8.5 2.698c.52.165.872.647.872 1.191V9.9c0 .69-.56 1.25-1.25 1.25h-17c-.69 0-1.25-.56-1.25-1.25V8.623c0-.544.353-1.026.872-1.191l8.5-2.698zM16 6.187l-8.25 2.62v.843h16.5v-.844L16 6.187z"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 15.25,
    y: 12,
    width: 1.5,
    height: 7,
    rx: 0.75
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 9.25,
    y: 12,
    width: 1.5,
    height: 7,
    rx: 0.75
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 21.25,
    y: 12,
    width: 1.5,
    height: 7,
    rx: 0.75
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7 21.25a.75.75 0 01.75-.75h16.5a.75.75 0 010 1.5H7.75a.75.75 0 01-.75-.75zM6 24.25a.75.75 0 01.75-.75h18.5a.75.75 0 010 1.5H6.75a.75.75 0 01-.75-.75z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPayoutSettings);
export default __webpack_public_path__ + "static/media/payout-settings.ba6e34d4de78a248f16c3522c6ebedbd.svg";
export { ForwardRef as ReactComponent };